import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {stepEnum, paymentType} from '../Constants/debtPaymentEnum';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import RadioInput from 'app/Components/Shared/RadioInput/RadioInput';
import Tooltip from 'app/Components/Shared/Tooltip/Tooltip';
import {DebtPaymentBitWrapper} from '../DebtPaymentBitWrapper';
import {useDebtPaymentSelectPaymentOption} from '../hooks/useDebtPaymentSelectPaymentOption';
import useEnterKeyPress from '../hooks/useEnterKeyPress';
import {useDebtPaymentBit} from '../DebtPaymentBitWrapper';
import {isMobile} from 'react-device-detect';
import {dwhBanReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';
import {formatAmount} from '../utils/banTypeClassifier';
import Image from 'app/Components/Shared/Image/image';

const SelectPaymentOption = () => {
  const {getPaymentStatusesForBan} = useDebtPaymentBit();
  const {selectedBanData, paymentAmount, bitReturnEvent, selectedPaymentType, bitIsReady, currentStep, actions} =
    useDebtPaymentSelectPaymentOption();
  const loginData = useSelector((state) => state.authentication.loginData);
  const yDaysCount = useSelector((state) => state.debtAndUpdatePayment.paymentStatusDisplayDaysY);
  const yDaysCountEnergy = useSelector((state) => state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY);
  const bitTooltipText = `התשלום באמצעות Bit מבוצע באתר אינטרנט או ביישומון Bit, בהתאם לתנאי הפרטיות של בנק הפועלים בע״מ ומותנה בקיומו של משתמש רשום ב-Bit. בבחירת אפשרות תשלום זו ניתנת הסכמתך להעברת פרטיך (מספר טלפון וסכום לתשלום) לבנק הפועלים.`;
  const ban = selectedBanData?.banNumber;
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (currentStep === stepEnum.SELECTPAYMENTTYPE) {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.ChoosePaymentMethodPage,
        messageText: DWHMessageText.DebtChoosePaymentMethodDisplayed,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
    }
  }, []);
  const radioBtns = [
    {
      id: 'creditcard',
      label: (
        <div className='select_payment_type-label'>
          <span className='select_payment_type-label-icon'>
            <Image src={require('../images/credit_card.svg')} alt='cc' />
          </span>
          <span>כרטיס אשראי (כולל כרטיסי דביט)</span>
        </div>
      ),
      value: 'creditcard',
    },
    {
      id: 'bit',
      label: (
        <div className='select_payment_type-label'>
          <span className='select_payment_type-label-icon'>
            <Image src={require('../images/bit.svg')} alt='Bit' />
          </span>
          <span>Bit</span>
        </div>
      ),
      value: 'bit',
    },
  ];

  const onRadioBtnChange = (e) => {
    let value = e.currentTarget.value;
    actions.setPaymentType(value);
    setShowError(false);
  };

  const setSelectedForUpdate = () => {
    if (!selectedPaymentType) {
      setShowError(true);
      return;
    }
    if (selectedPaymentType == paymentType.BIT) {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.ChoosePaymentMethodPage,
        messageText: DWHMessageText.BitPaymentMethodButtonClicked,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
      getPaymentStatusesForBan(ban);
    } else {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.ChoosePaymentMethodPage,
        messageText: DWHMessageText.CreditCardPaymentMethodButtonClicked,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
      actions.goToStep(stepEnum.CREDITCARD);
    }
  };

  useEnterKeyPress(setSelectedForUpdate);

  const renderSelectPaymentOption = () => {
    return (
      <div className='select-payment-type-top-container'>
        <div className='background payment-info'>
          חשבון {selectedBanData.banNumber} | סה״כ לתשלום: <span className='red'>₪{formatAmount(paymentAmount)}</span>
        </div>
        <div className={`${isMobile ? 'm-title' : 'l-title'} extra`} dangerouslySetInnerHTML={{__html: 'איך נוח לך לשלם?'}} />
      </div>
    );
  };
  const renderPaymentFailed = () => {
    const getTitle = () => {
      if (currentStep == stepEnum.CREDITPAYMENTERROR) {
        return 'מספר התשלומים לסוג אשראי זה <br /> חייב להיות מעל 2';
      }
      return 'משהו השתבש ולא הצלחנו <br />להשלים את החיוב';
    };
    return (
      <div className='select-payment-type-top-container failed'>
        <Image src={require('../images/failed.svg')} alt='' className='step-icon' />
        <div className={`${isMobile ? 'm-title' : 'l-title'} extra`} dangerouslySetInnerHTML={{__html: getTitle()}} />
        <div className='s-title old-600'>ניתן לשלם באחת הדרכים הבאות</div>
      </div>
    );
  };

  return (
    <div className='debtpayment-step select-payment-type'>
      {currentStep == stepEnum.SELECTPAYMENTTYPE ? renderSelectPaymentOption() : renderPaymentFailed()}

      <div className='select-payment-type-radio'>
        {radioBtns.map((rb) => {
          return (
            <div className={`radio-btn-item ${selectedPaymentType == rb.value ? 'checked' : ''} ${rb.value}`} key={rb.id}>
              <RadioInput
                checked={selectedPaymentType == rb.value}
                id={rb.id}
                name='paymentoption'
                value={rb.value}
                label={rb.label}
                onChange={onRadioBtnChange}
              />
            </div>
          );
        })}
      </div>
      <div className='bit-tooltip'>
        <div className='bit-tooltip-title' id={'bitTooltip'}>
          מידע נוסף על ארנקים דיגיטליים
        </div>
        <Tooltip title={''} text={bitTooltipText} target={`bitTooltip`} placement={'top'} cellcomdefault={true} showCloseButton={true} />
      </div>
      <div className={`continue-button ${currentStep != stepEnum.SELECTPAYMENTTYPE ? 'bottom' : ''}`}>
        {showError && <span className='error'>כדי להמשיך יש לבחור אמצעי תשלום</span>}
        <BtnSubmit text='המשך ' onclick={setSelectedForUpdate} />
      </div>

      <DebtPaymentBitWrapper ban={ban} paymentAmount={paymentAmount} bitReturnEvent={bitReturnEvent} bitIsReady={bitIsReady} />
    </div>
  );
};

export default SelectPaymentOption;
